import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PrivacySection = (props: { title: string; description: string; img: string }) => {
  const { title, description, img } = props;
  return (
    <Box>
      <Typography
        variant={"h6"}
        color={""}
        gutterBottom
        sx={{
          fontWeight: "medium",
        }}
      >
        {title}
      </Typography>
      <Typography component={"p"} color={""}>
        {description}
      </Typography>
      <img src={img} className="block max-w-[100%] mt-[10px] mx-auto" alt="" />
    </Box>
  );
};

const Content = () => {
  const data = [
    {
      title: "1. Creating an Alert",
      description:
        "You can set up an alert on the real-time search page, the routes page, or on your alert page. Simply select your desired flight criteria and click on \"create.\"",
      img: "https://img.awardtool.com/guides/alerts_create_2.png",
    },
    {
      title: "2. Alert Notification via Email",
      description:
        "We'll perform multiple daily searches on your behalf, so you don't have to. When we find flights that match your criteria, we'll promptly send you an email to share the good news. Once you receive the notification, we'll mark the alert as completed. If you wish, you can re-enable the alert if you want us to continue searching for suitable flights.",
        img: "https://img.awardtool.com/guides/alerts_email.png",
    },
    {
      title: "How are the alerts counted?",
      description:
        "Each entry you set is counted as one alert. This means that one origin, one arrival, and one day.",
    },
    {
      title: "How can I receive more alerts?",
      description:
        "Upgrade to the pro version to receive up to 25 alerts for each account.",
    },
    // {
    //   title: "6. How long do we keep your information?",
    //   description:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    //   img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    // },
    // {
    //   title: "7. What are your privacy rights?",
    //   description:
    //     "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?",
    //   img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    // },
    // {
    //   title: "8. How can you review, update or delete the data we collect from you?",
    //   description:
    //     "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?",
    //   img: "https://img.awardtool.com/city_imgs/san_francisco.jpg",
    // },
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
